import React, { useCallback, useEffect, useMemo, useState } from "react";
import AddProduct from "../components/product/AddProduct.jsx";
import api from "../api/api.js";
import { styleDate, truncateText } from "../utils/Uility.js";
import { Paginate } from "../components/Paginate.jsx";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import AddSuppliers from "../components/shipping/AddSuppliers.jsx";
import {
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
} from "@material-tailwind/react";
import {
  BuildingStorefrontIcon,
  ShoppingCartIcon,
} from "@heroicons/react/24/solid";
import { decrypt } from "../utils/CryptData.js";
import { toast } from "react-toastify";

const getStatusClass = (status) => {
  if (status.includes("attente")) return "bg-orange-100 text-orange-700";
  if (status.includes("Réfusé")) return "bg-red-200 text-red-700";
  return "bg-green-200 text-green-700";
};

export default function Dashboard() {
  const [data, setData] = useState({
    user: 0,
    order: 0,
    totalPeding: 0,
    totalShipped: 0,
    totalRefuse: 0,
    infoUser: [],
    suppliers: [],
  });

  const loginState = useSelector((state) => state.auth.isLoggedIn);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedTab, setSelectedTab] = useState("Commandes");
  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({ open: false, item: null, status: "" });

  const navigate = useNavigate();

  const tabHeader = [
    { label: "Commandes", value: "Commandes", icon: ShoppingCartIcon },
    {
      label: "Fournisseurs",
      value: "fournisseur",
      icon: BuildingStorefrontIcon,
    },
  ];
  const account = [
    {
      label: "Total clients",
      value: data.user,
      color: "orange",
      path: (
        <svg
          className="w-7 h-7"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
        >
          <path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z" />
        </svg>
      ),
    },
    {
      label: "Total commandes",
      value: data.order,
      color: "indigo",
      path: (
        <svg
          className="w-7 h-7"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
        </svg>
      ),
    },
    {
      label: "Commandes expédiées",
      value: data.totalShipped,
      color: "green",
      path: (
        <svg
          className="w-7 h-7"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
        >
          <path d="M112 0C85.5 0 64 21.5 64 48l0 48L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 160l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 176 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 224l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 288l0 128c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L112 0zM544 237.3l0 18.7-128 0 0-96 50.7 0L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z" />
        </svg>
      ),
    },
    {
      label: "Commande en attente",
      value: data.totalPeding,
      color: "blue",
      path: (
        <svg
          className="w-7 h-7"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
        >
          <path d="M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM96 75l0-11 192 0 0 11c0 19-5.6 37.4-16 53L112 128c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9L112 384z" />
        </svg>
      ),
    },
    {
      label: "Commande refusée(s)",
      value: data.totalRefuse,
      color: "red",
      path: (
        <svg
          className="w-7 h-7"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
        </svg>
      ),
    },
    {
      label: "fournisseurs",
      value: data.totalSuppliers,
      color: "yellow",
      path: (
        <svg
          className="w-7 h-7"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
        >
          <path d="M64 32C28.7 32 0 60.7 0 96L0 304l0 80 0 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16L416 384l33.6 0c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l1.6 0c17.7 0 32-14.3 32-32l0-64 0-16 0-10.3c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5L480 144l0-48c0-35.3-28.7-64-64-64L64 32zM585 256l-105 0 0-64 48.8 0c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
        </svg>
      ),
    },
  ];
  const headers = useMemo(
    () => ({
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${
          JSON.parse(decrypt(localStorage.getItem("dus")))?.token || ""
        }`,
      },
    }),
    []
  );
  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const userResponse = await api.get("/users", headers);
      const orderResponse = await api.get("/orders", headers);
      const peddingResponse = await api.get("/orders/orderPedding");
      const shippedResponse = await api.get("/orders/orderShipped");
      const refuseResponse = await api.get("/orders/orderRefuse");
      const historyResponse = await api.get(
        `/orders/OrderHistory?page=${currentPage}`,
        headers
      );
      const supplierResponse = await api.get(
        `/products/suppliers?page=${currentPage}`
      );

      setData({
        user: userResponse.data.total ?? 0,
        order: orderResponse.data.total ?? 0,
        totalPeding: peddingResponse.data.totalItems ?? 0,
        totalShipped: shippedResponse.data.totalItems ?? 0,
        totalRefuse: refuseResponse.data.totalItems ?? 0,
        infoUser: historyResponse.data.history ?? [],
        totalSuppliers: supplierResponse.data.total ?? 0,
        suppliers: supplierResponse.data ?? {},
      });
      setTotalPages(historyResponse.data.totalPages ?? 1);
    } catch (error) {
      toast.error("Erreur lors du chargement des données. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  }, [currentPage, headers]);

  const handleStatusClick = (item, status) => {
    setConfirmDialog({ open: true, item, status });
  };

  const confirmStatusUpdate = async () => {
    if (!confirmDialog.item || !confirmDialog.status) return;

    setIsUpdating(true);
    try {
      const dataUpdate = { status: confirmDialog.status, order_id: confirmDialog.item.order_id };
      await api.put("/orders/orderStatus", dataUpdate, headers);
      toast.success(`Commande mise à jour: ${confirmDialog.status}`);
      await fetchData();
    } catch (error) {
      toast.error("Erreur lors de la mise à jour du statut. Veuillez réessayer.");
    } finally {
      setIsUpdating(false);
      setConfirmDialog({ open: false, item: null, status: "" });
    }
  };

  const cancelStatusUpdate = () => {
    setConfirmDialog({ open: false, item: null, status: "" });
  };

  const handlePageChange = async (page) => {
    setIsLoading(true);
    try {
      setCurrentPage(page);
      const result = await api.get(`/orders/OrderHistory?page=${page}`, headers);
      setData((prevData) => ({ ...prevData, infoUser: result.data.history ?? [] }));
      setTotalPages(result.data.totalPages ?? 1);
    } catch (error) {
      toast.error("Erreur lors du chargement de l'historique.");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChangeSupp = async (page) => {
    setIsLoading(true);
    try {
      setCurrentPage(page);
      const result = await api.get(`/products/suppliers?page=${page}`, headers);
      setData((prevData) => ({
        ...prevData,
        suppliers: result.data ?? {},
      }));
      setTotalPages(result.data.totalPages ?? 1);
    } catch (error) {
      toast.error("Erreur lors du chargement des fournisseurs.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      !loginState ||
      !JSON.parse(decrypt(localStorage.getItem("dus")))?.token
    ) {
      navigate("/");
      return;
    }
    fetchData();
  }, [loginState, navigate, fetchData]);

  // Loading skeleton component
  const TableSkeleton = () => (
    <div className="animate-pulse">
      <div className="h-10 bg-gray-200 rounded mb-4"></div>
      {[...Array(5)].map((_, i) => (
        <div key={i} className="h-16 bg-gray-100 rounded mb-2"></div>
      ))}
    </div>
  );

  return (
    <main className="px-6 py-5">
      {/* Confirmation Dialog */}
      {confirmDialog.open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
            <h3 className="text-lg font-semibold mb-4">Confirmer la mise à jour</h3>
            <p className="text-gray-600 mb-6">
              Voulez-vous vraiment changer le statut de cette commande en "{confirmDialog.status}" ?
            </p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={cancelStatusUpdate}
                className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                disabled={isUpdating}
              >
                Annuler
              </button>
              <button
                onClick={confirmStatusUpdate}
                className={`px-4 py-2 rounded-lg text-white transition-colors flex items-center gap-2 ${
                  confirmDialog.status === "Réfusé"
                    ? "bg-red-500 hover:bg-red-600"
                    : "bg-green-500 hover:bg-green-600"
                }`}
                disabled={isUpdating}
              >
                {isUpdating && (
                  <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                )}
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-between py-6 my-5">
        <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-200">
          Dashboard
        </h2>
        <div className="flex gap-4">
          <AddSuppliers onSupplierAdded={fetchData} />
          <AddProduct />
        </div>
      </div>

      {/* Cards */}
      <div className="grid gap-6 mb-8 md:grid-cols-2 xl:grid-cols-4">
        {account.map(({ label, value, color, path }) => (
          <div
            key={label}
            className={`flex items-center p-4 bg-white rounded-lg shadow-xs  text-${color}-500`}
          >
            <div
              className={`p-3 mr-4  rounded-full bg-${color}-500 bg-opacity-25`}
            >
              {path}
            </div>
            <div>
              <p className="mb-2 text-md font-semibold text-gray-600 dark:text-gray-400">
                {label}
              </p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {value}
              </p>
            </div>
          </div>
        ))}
      </div>

      <Tabs value={selectedTab}>
        <TabsHeader className="w-4/12">
          {tabHeader.map(({ label, value, icon }) => (
            <Tab
              key={value}
              value={value}
              onClick={() => setSelectedTab(value)}
            >
              <div className="flex items-center gap-2">
                {React.createElement(icon, { className: "w-5 h-5" })}
                {label}
              </div>
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody>
          {tabHeader.map(({ label, value }, index) => (
            <TabPanel key={index} value={value}>
              {label === "Commandes" ? (
                <>
                  <div className="w-full overflow-hidden pb-28 rounded-lg">
                    <table className="w-full whitespace-no-wrap min-w-[640px]">
                      <thead>
                        <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
                          <th className="px-4 py-3">Reference commande</th>
                          <th className="px-4 py-3">Client</th>
                          <th className="px-4 py-3">Produit</th>
                          <th className="px-4 py-3">Quantité</th>
                          <th className="px-4 py-3">Amount</th>
                          <th className="px-4 py-3">Status</th>
                          <th className="px-4 py-3">Date</th>
                          <th className="px-4 py-3">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                        {isLoading ? (
                          <tr>
                            <td colSpan="8" className="px-4 py-8">
                              <TableSkeleton />
                            </td>
                          </tr>
                        ) : data.infoUser.length > 0 ? (
                          data.infoUser.map((item, index) => (
                            <tr
                              className="text-gray-700 dark:text-gray-400"
                              key={index}
                            >
                              <td className="px-4 py-3 text-sm">
                                {truncateText(item.order_id, 18)}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {item.customer_name}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {item.product_name}
                                <p className="text-xs text-gray-600 dark:text-gray-400">
                                  {truncateText(item.product_description, 30)}
                                </p>
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {item.quantity}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {item.total_price} Fr
                              </td>
                              <td className="px-4 py-3 text-xs">
                                <span
                                  className={`px-2 py-1 font-semibold leading-tight ${getStatusClass(
                                    item.status
                                  )} rounded-full`}
                                >
                                  {item.status}
                                </span>
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {styleDate(item.order_date)}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {(item.status.includes("attente") ||
                                  item.status.includes("Réfusé")) && (
                                  <details className="dropdown">
                                    <summary className="btn m-1">
                                      Mettre à jour la commande
                                    </summary>
                                    <ul className="menu dropdown-content bg-base-100 z-10 rounded-box w-40 p-2 gap-2">
                                      {item.status.includes("Réfusé") ? (
                                        <li
                                          onClick={() =>
                                            handleStatusClick(item, "expédié")
                                          }
                                          className="btn bg-green-500 hover:bg-green-700 text-white"
                                        >
                                          expédié
                                        </li>
                                      ) : (
                                        <>
                                          <li
                                            onClick={() =>
                                              handleStatusClick(item, "expédié")
                                            }
                                            className="btn bg-green-500 hover:bg-green-700 text-white"
                                          >
                                            expédié
                                          </li>
                                          <li
                                            onClick={() =>
                                              handleStatusClick(item, "Réfusé")
                                            }
                                            className="btn bg-red-500 hover:bg-red-700 text-white"
                                          >
                                            Réfusé
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </details>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="8"
                              className="px-4 py-3 text-center text-gray-700 text-2xl dark:text-gray-400"
                            >
                              Pas de commande effectué
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {data.infoUser.length > 0 && (
                    <Paginate
                      listproductLength={{ page: currentPage, totalPages }}
                      handlePage={handlePageChange}
                    />
                  )}
                </>
              ) : (
                <>
                  <div className="w-full overflow-hidden pb-28 rounded-lg">
                    <table className="w-full whitespace-no-wrap min-w-[640px]">
                      <thead>
                        <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
                          <th className="px-4 py-3">Reference</th>
                          <th className="px-4 py-3">Nom</th>
                          <th className="px-4 py-3">Contact</th>
                          <th className="px-4 py-3">Addresse</th>
                          <th className="px-4 py-3">Email</th>
                          <th className="px-4 py-3">Pays</th>
                          <th className="px-4 py-3">Ville</th>
                          <th className="px-4 py-3">Personne à contacter</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                        {isLoading ? (
                          <tr>
                            <td colSpan="8" className="px-4 py-8">
                              <TableSkeleton />
                            </td>
                          </tr>
                        ) : data.suppliers.suppliers?.length > 0 ? (
                          data.suppliers.suppliers?.map((item, index) => (
                            <tr
                              className="text-gray-700 dark:text-gray-400"
                              key={index}
                            >
                              <td className="px-4 py-3 text-sm">
                                {truncateText(item.id, 18)}
                              </td>
                              <td className="px-4 py-3 text-sm">{item.name}</td>
                              <td className="px-4 py-3 text-sm">
                                {" "}
                                {item.phone}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {truncateText(item.address, 30)}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {item.email}
                              </td>
                              <td className="px-4 py-3 text-sm">
                                {item.country}
                              </td>
                              <td className="px-4 py-3 text-sm">{item.city}</td>

                              <td className="px-4 py-3 text-sm">
                                {item.contact_person}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="8"
                              className="px-4 py-3 text-center text-gray-700 text-2xl dark:text-gray-400"
                            >
                              Pas de donnée
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {data.suppliers.length > 0 && (
                    <Paginate
                      listproductLength={{
                        page: currentPage,
                        totalPages: data.suppliers.totalPages,
                      }}
                      handlePage={handlePageChangeSupp}
                    />
                  )}
                </>
              )}
              {/* {(label === "Tout" ? listproduct : datas) && (
                <Paginate listproductLength={{ page: currentPage, totalPages }} handlePage={handlePageChange} />
              )} */}
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs>

      {/* Table */}
    </main>
  );
}
